// @import "node_modules/@se/web-ui/styles/_theme.scss";
@import "../../../styles/variables.scss";

.faq-widget__title {
  font-size: 18px;
  font-weight: 700;
  margin-top: 0;
  margin-bottom: 20px;
  @media (max-width: $uiaas-tablet) {
    font-size: 16px;
  }
}

.faq-widget__subtitle {
  @media (max-width: 780px) {
    display: none;
  }
}

.faq-widget {
  background-color: #ffffff;
  padding: 20px;
  margin-top: 20px;
  box-shadow: 0px 2px 10px 0px rgba(51, 51, 51, 0.15);
  color: #333333;
  @media (max-width: $uiaas-tablet) {
    padding: 16px;
  }
}

.faq-widget--uiaas {
  @extend .faq-widget;
  @media (min-width: 780px) {
    margin-right: 20px;
  }
}
.faq-widget--uiaas[dir="rtl"] {
  @media (min-width: 780px) {
    margin-right: 0px;
    margin-left: 20px;
  }
}

.faq-widget--dashboard {
  margin: 0;

  @media (max-width: $uiaas-tablet) {
    box-shadow: none;
  }

  uiaas-dashboard-tab-button {
    display: block;
    margin-top: 20px;

    @media (max-width: $uiaas-tablet) {
      margin-top: 8px;
    }
  }
}

.faq-widget--uiaas[dir="rtl"] {
  @media (min-width: $uiaas-tablet) {
    margin-left: 0;
    margin-right: 0;
  }
}

.question {
  font-size: 18px;
  line-height: 21px;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  border-top: 1px solid #e7e6e6;
}

.question-text {
  margin: 20px 0 20px 20px;
  @media (max-width: $uiaas-tablet) {
    margin-left: 8px;
  }
}

.opened {
  .question {
    border-bottom: 1px solid transparent;
  }
}

.answer-text {
  font-size: 14px;
  margin: 0 40px 0 20px;

  @media (max-width: $uiaas-tablet) {
    margin: 0 8px;
  }
}

.highlight {
  font-weight: bold;
}

.more-link {
  padding: 20px 0 20px 20px;
  @media (max-width: $uiaas-tablet) {
    display: flex;
    justify-content: flex-end;
    padding-right: 20px;
  }
}

.button-faq {
  border: none;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 10px;
  margin-right: 8px;
  cursor: pointer;
}

@media (min-width: 720px) {
  .button-faq {
    margin-left: 20px;
    margin-right: 18px;
  }
}

.button-faq__arrow {
  height: 10px;
  width: 10px;
  transform: rotate(135deg);
  border-top: 2px solid rgb(51, 51, 51);
  border-right: 2px solid rgb(51, 51, 51);
  margin-bottom: 8px;
  cursor: pointer;

  &--rotated {
    @extend .button-faq__arrow;
    transform: rotate(-45deg);
    transform-origin: 100% 75%;
    margin-bottom: 4px;
  }
}

@media (min-width: 720px) {
  .button-faq__arrow {
    height: 14px;
    width: 14px;
  }
}

.faq-item.opened {
  background-color: #fafafa;
  cursor: pointer;
}

.faq__view-all-container {
  border-top: 1px solid #e7e6e6;
  padding-top: 20px;
}

.faq__view-all {
  font-size: 16px;
  text-decoration: none;
  color: rgba(26, 13, 171, 1);
  &:hover {
    text-decoration: underline;
  }
}

[dir="rtl"] .question-text {
  margin: 20px 20px 20px 0px;
  @media (max-width: $uiaas-tablet) {
    margin-right: 8px;
  }
}

[dir="rtl"] .answer-text {
  margin: 0 20px 0 40px;
  @media (max-width: $uiaas-tablet) {
    margin: 0 8px;
  }
}
